/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * CampaignInfo actions
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    CAMPAIGN_INFO_ACTIVATE_START,
    CAMPAIGN_INFO_ACTIVATE_SUCCESS,
    CAMPAIGN_INFO_GET_ACTIVATE_TYPE,
    CAMPAIGN_INFO_INIT_FAILURE,
    CAMPAIGN_INFO_INIT_START,
    CAMPAIGN_INFO_INIT_SUCCESS, CAMPAIGN_INFO_LINK_VISITED,
    CAMPAIGN_INFO_REMOVE,
} from './campaignInfoConstant';
import {
    TCampaignInfoActivateStartAction,
    TCampaignInfoActivateSuccessAction,
    TCampaignInfoActivateSuccessPayload,
    TCampaignInfoGetActivateTypeAction,
    TCampaignInfoInitFailureAction,
    TCampaignInfoInitStartAction,
    TCampaignInfoInitStartPayload,
    TCampaignInfoInitSuccessAction,
    TCampaignInfoInitSuccessPayload, TCampaignInfoLinkVisitedAction,
    TCampaignInfoRemoveAction,
} from './types/campaignInfoActionTypes';

/*
* -------------------------------------------
*            INIT PAGE
* -------------------------------------------
*/

export const campaignInfoInitStartAction = (payload: TCampaignInfoInitStartPayload): TCampaignInfoInitStartAction =>
    createAction(CAMPAIGN_INFO_INIT_START, payload);

export const campaignInfoInitSuccessAction = (payload: TCampaignInfoInitSuccessPayload):
    TCampaignInfoInitSuccessAction =>
    createAction(CAMPAIGN_INFO_INIT_SUCCESS, payload);

export const campaignInfoInitFailureAction = (): TCampaignInfoInitFailureAction =>
    createAction(CAMPAIGN_INFO_INIT_FAILURE);

export const campaignInfoLinkVisitedAction = (payload: TCampaignInfoInitStartPayload): TCampaignInfoLinkVisitedAction =>
    createAction(CAMPAIGN_INFO_LINK_VISITED, payload);

/*
* -------------------------------------------
*      Send inquiry (from modal apply)
* -------------------------------------------
*/

// Activate
export const campaignInfoGetActivateTypeAction = (): TCampaignInfoGetActivateTypeAction =>
    createAction(CAMPAIGN_INFO_GET_ACTIVATE_TYPE);

export const campaignInfoActivateStartAction = (): TCampaignInfoActivateStartAction =>
    createAction(CAMPAIGN_INFO_ACTIVATE_START);

export const campaignInfoActivateSuccessAction = (payload: TCampaignInfoActivateSuccessPayload):
    TCampaignInfoActivateSuccessAction =>
    createAction(CAMPAIGN_INFO_ACTIVATE_SUCCESS, payload);

// Remove

export const campaignInfoRemoveAction = (): TCampaignInfoRemoveAction =>
    createAction(CAMPAIGN_INFO_REMOVE);
